import React from 'react';
import { MapPin } from 'lucide-react';

const AddressCard = ({ selectedAddress, onOpenSelector, onOpenAddModal, loading }) => {
  if (loading) {
    return (
      <div className="skeleton-card">
        <div className="skeleton-base skeleton-title" />
        <div className="skeleton-base skeleton-text-lg" style={{ width: '80%' }} />
        <div className="skeleton-base skeleton-text-md" style={{ width: '60%' }} />
        <div className="skeleton-base skeleton-text-md" style={{ width: '50%' }} />
        <div className="skeleton-base skeleton-btn" style={{ marginTop: '16px' }} />
      </div>
    );
  }

  return (
    <div className="checkout-card address-card-selected">
      <h3 className="checkout-card-title">
        <MapPin size={18} color="#ff7a00" />
        <span>Delivery Address</span>
      </h3>
      
      {selectedAddress ? (
        <div>
          <div className="address-info-simplified">
            <div className="address-shop-name">{selectedAddress.shopName}</div>
            <div className="address-contact-person">{selectedAddress.contactPerson}</div>
            <div className="address-phone">{selectedAddress.phone}</div>
            <div className="address-details-block">
              {selectedAddress.street}, {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.postalCode}, {selectedAddress.country}
            </div>
          </div>

          <div className="address-card-actions" style={{ marginTop: '16px' }}>
            <button 
              type="button" 
              onClick={onOpenSelector} 
              className="btn-secondary"
            >
              Change Address
            </button>
            <button 
              type="button" 
              onClick={onOpenAddModal} 
              className="btn-secondary"
            >
              Add Address
            </button>
          </div>
        </div>
      ) : (
        <div className="empty-addresses-state">
          <p>No delivery address selected or found.</p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button 
              type="button" 
              onClick={onOpenSelector} 
              className="btn-secondary"
            >
              Select Saved Address
            </button>
            <button 
              type="button" 
              onClick={onOpenAddModal} 
              className="btn"
            >
              Add New Address
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressCard;
